/**
 * 1901 から 現在年 までの生まれ年選択値一覧を作成する
 * @return 生まれ年選択値一覧(年数の降順)
 */
export const createBirthYearSelectValues = () => {
	const start = 1901;
	const end = new Date().getFullYear();

	const values: number[] = [];
	for (let i = start; i <= end; i++) {
		values.push(i);
	}

	return values.reverse();
};
